module.exports = __webpack_public_path__ + "static/media/img_social02.48ae7f05.jpg";